<template>
	<section class="container container_main-content claim">
		<h1 class="heading heading-title">{{ $t('our_services') }}</h1>
		<div class="icon__divider">
			<span class="icon icon__divider-outer">
				<span class="icon icon__divider-inner"></span>
			</span>
		</div>
		<article class="article article__content">
			<ul class="article__content-item article__content-item-primary">
				<li class="service__item" v-for="(service, key) in services" :key="key">
					<div class="service__row-top">
						<div class="service__description service__description-top">
							<div class="service-details__tags booking-small">
								<span v-for="(tag, i) in service.tags" :key="i" class="service-details__tags-item">{{ tag }}</span>
							</div>
						</div>
						<div class="service__header service__header-multi">
							<div class="service__section service__section-left">
								<h4 class="service__name heading heading-content-title">{{ service.name }}</h4>
							</div>

							<!-- <div class="service__section service__section-right"> -->
							<!-- <span class="service__price heading-caption">Cena</span> -->
							<!-- <span class="service__price heading-caption">/</span> -->
							<!-- <span class="service__price heading-caption">Čas</span> -->
							<!-- </div> -->
						</div>
						<div class="service__description service__description-bottom">
							<div class="service-details__tags service-details__tags-provider booking-small">
								<div v-for="(barber, i) in service.barbers" :key="i" class="service-details__tags-providers-item">
									<div class="service-details__tags-providers-item_provider">
										<span class="service-details__tags-providers-item_provider-name">{{ barber.name }}</span>
										<span class="service-details__tags-providers-item_provider-rank">{{ barber.rank }}</span>
									</div>
									<div class="service-details__tags-providers-item_properties">
										<span>{{ $n(barber.price, 'currency') }}</span>
										<span v-if="barber.duration">/</span>
										<span v-if="barber.duration">{{ barber.duration }}min</span>
									</div>
								</div>
							</div>
						</div>
						<div class="service__description">
							<p class="content-default">{{ service.description }}</p>
						</div>
					</div>
				</li>
			</ul>
		</article>
	</section>
</template>

<script>
export default {
	data() {
		return {
			services: [],
		}
	},

	async created() {
		let { data } = await this.$http.get('service')
		this.services = data
	},
}
</script>

<style lang="scss" scoped></style>
